import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const lithuania: MarketConfiguration = {
  code: MarketEnum.lt,
  label: "Lithuania",
  descriptiveLabel: "Lithuanian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Lithuania",
  locale: LocaleEnum.lt,
  serviceLocale: ServiceLocaleEnum.lt,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-lt",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.lt,
  adyenMarket: MarketEnum.lt,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default lithuania;
